import React from 'react';
import { Box } from '@chakra-ui/core';
import { ViewRequisitionDetail } from '../../seeker/candidate/history/ViewRequisitionDetail';
import useSingleRequisitionByPosition from '../../seeker/candidate/profile/components/useSingleRequisitionByPosition';
import { RequisitionDetailsView } from '../../../dashboard/requisitionOverview/requisitionDetails/RequisitionDetailsView';
import { Requisition } from '../../../../firebase/firestore/documents/requisition';
import { NewRequisition } from '../../../dashboard/requisitionOverview/requisitionDetails/types/requistionDetails';
import { isNewRequisition } from '../../../dashboard/requisitionOverview/requisitionDetails/utils/requisitionDetailsUtils';

export type ViewSingleRequisitionDetailProps = {
  isOpen: boolean;
  onClose: () => void;
  positionId: string;
  requisitionId: string;
};

const ViewSingleRequisitionDetail = ({
  isOpen,
  onClose,
  positionId,
  requisitionId,
}: ViewSingleRequisitionDetailProps): JSX.Element => {
  const singleRequisition = useSingleRequisitionByPosition(positionId, requisitionId);

  return (
    <Box>
      {singleRequisition &&
        (isNewRequisition(singleRequisition?.[0] as Requisition | NewRequisition) ? (
          <RequisitionDetailsView
            isOpen={isOpen}
            onClose={onClose}
            requisition={singleRequisition?.[0] as NewRequisition}
            shouldCompare={false}
          />
        ) : (
          <ViewRequisitionDetail isOpen={isOpen} onClose={onClose} requisition={singleRequisition?.[0]} shouldCompare={false} />
        ))}
    </Box>
  );
};

export default ViewSingleRequisitionDetail;
